module.exports = __webpack_public_path__ + "static/media/designPatent_30-0990422.45595c8e.png";